<template>
  <transition name="fade" appear>
    <section>
      <svg width="0" height="0" style="position: absolute">
        <defs>
          <clipPath id="gameTicket" clipPathUnits="objectBoundingBox">
            <path
              d="M0.895,0 H0 C0.023,0.006,0.068,0.03,0.068,0.085 V0.895 C0.067,0.921,0.083,1,0.187,1 H1 V0.093 C1,0.015,0.93,-0.001,0.895,0"
            />
          </clipPath>
        </defs>
      </svg>
      <PageTitles
        :h1="$store.state.heading[props.type]"
        h2="Choose the Game of Your Interest"
      />
      <div v-if="!games || games?.length === 0">
        <CheckBack :message="linkMessage[props.type]" url=""/>
      </div>
      <div class="ui_wrapper" v-else>      
      <div class="ui">
          <GameTicket
            v-for="(game, id) in gamesLeft"
            :icon="game.Icon.path"
            :primetimeLogo="game.PrimetimeLogo?.path"
            :title="game.Title"
            :link="game[linkLocation[props.type]]"
            :date="game.Date"
            :time="game.Time"
          />
        </div>
        <div class="ui">
          <GameTicket
            v-for="(game, id) in gamesRight"
            :icon="game.Icon.path"
            :primetimeLogo="game.PrimetimeLogo?.path"
            :title="game.Title"
            :link="game[linkLocation[props.type]]"
            :date="game.Date"
            :time="game.Time"
          />
        </div>
      </div>
    </section>
  </transition>
  <div class="upgrade-holder">
    <!-- <AlternatePlan
      :downgrade="false"
      upgradeTitle="Multi-Game Plans"
      upgradeLink="Multi-Game Plans"
      upgradeTitleWithCallToAction="View Multi-Game Plans"
      :benefits="[]"
      startingAt="$100 per ticket"
      deposits
    /> -->
  </div>
</template>
<script setup>
import axios from "axios";
import { useStore } from "vuex";
import { ref } from "vue";
import PageTitles from "@/components/PageTitles";
import GameTicket from "@/components/GameTicket";
import AlternatePlan from "@/components/AlternatePlan";
import CheckBack from "@/components/CheckBack";
const props = defineProps({
  type: String,
});
const linkLocation = {
  "large-group": "GroupTicketsPurchaseLink",
  single: "SingleGameTicketsPurchaseLink",
};
const linkMessage = {
  "large-group": "Please check back in May 2025 when the 2025 NFL schedule is released to learn more about group tickets.",
  single: "Please check back in May 2025 when the 2025 NFL schedule is released to learn more about single-game tickets.",
};

const store = useStore();
let games = ref([]);
let gamesLeft = ref([]);
let gamesRight = ref([]);
axios
  .get(
    `${store.state.API_URL}/collections/get/Games?token=${store.state.API_TOKEN}`
  )
  .then(onGetGames);
function onGetGames(response) {
  if (response.status === 200) {
    let entries = response.data.entries;
    console.log(entries);
    games.value = entries.sort((a, b) => {
      let bDate = new Date(b.Date);
      let aDate = new Date(a.Date);
      return aDate - bDate;
    });
  }

  // TODO: I haven't tested this for odd numbers
  const gamesLength = games.value.length;
  const midpoint = Math.ceil(gamesLength / 2);

  gamesLeft.value = games.value.slice(0, midpoint);
  gamesRight.value = games.value.slice(midpoint);
}
</script>
<style lang="scss" scoped>
.upgrade-holder {
  max-width: 1200px;
  padding: 15px;
  margin: 0 auto;
  .upgrade {
    margin-left: auto;
    @media (min-width: 750px) {
      max-width: 50%;
    }
  }
}
section {
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
}
.ui_wrapper {
  display: flex;
  width: 100%;
  max-width: 1200px;
  @media (max-width: 750px) {
    flex-direction: column;
  }
}

.ui {
  display: grid;
  max-width: 1200px;
  padding: 15px 15px 0;
  margin: 0 auto;
  gap: 15px;
  width: 100%;
  @media (min-width: 750px) {
    grid-template-columns: 100%;
    > * {
      width: 100%;
    }
  }
}
</style>
